import React, { useState } from 'react';
import { Nav, NavItem, NavLink, TabContent, TabPane } from 'reactstrap';
import { Page, LoadingMsg } from "components/common";
import { Trans } from "react-i18next";
import ListDaily from "./ListDaily";
import ListMonthly from "./ListMonthly";
import SettingsClient from "../../Payroll/SettingsClient";
import { checkSettings } from "../../Payroll/checkSettings";

const List = (props) => {

  const [activeTab, setActiveTab] = useState('1');

  const [settingsData, setSettings] = useState();

  const loading = !settingsData || Object.keys(settingsData).length === 0;

  const settingsCheck = checkSettings(settingsData)
  const t = props.t

  const settingsLink = () => {
    window.location.href = `/payroll/settings`;
  };


return (
  <Page title={t('Shifts & Attendance')} showTitle={false}>
   <SettingsClient setSettings={setSettings}/>
   <div className='inv-tabs'>
      <Nav tabs className='mb-3'>
        <NavItem>
          <NavLink className={activeTab == '1' ? 'active' : ''} onClick={() => setActiveTab('1')}  style={{cursor:"pointer"}}>
            <Trans>Attendance Report Daily</Trans>
        </NavLink>
        </NavItem>
        <NavItem>
          <NavLink className={activeTab == '2' ? 'active' : ''} onClick={() => setActiveTab('2')}  style={{cursor:"pointer"}}>
            <Trans>Attendance Report Monthly</Trans>
          </NavLink>
        </NavItem>
      </Nav>
      {!loading ? (
       <>
      {settingsCheck.allFieldsFilled === true ? (
        <TabContent activeTab={activeTab}>
        { activeTab == 1 ?
              <TabPane tabId="1">
                  <ListDaily {...props}/>
              </TabPane>:
              <TabPane tabId="2"> 
                  <ListMonthly {...props}/>
                  {/* <ListCreditNotes match={`${match.url}/credit_notes`} allowCreate={true}/>  */}
              </TabPane>}
        </TabContent>
      ) : (
        <div className="alert alert-danger fade show my-3">
          <ul className="mb-0 pl-3 text-center">
            <span style={{cursor: "pointer"}} onClick={settingsLink}><Trans>Please Setup Payroll Accounts and It's Settings to Schedule and Run Attendance Reports.</Trans></span>
          </ul>
        </div>
        )}
      </>):(
        <LoadingMsg/>
      )}
    </div>
  </Page>
 );
}

export default List;